import { render, staticRenderFns } from "./TaskDelivery.vue?vue&type=template&id=1c8f4f84&scoped=true"
import script from "./TaskDelivery.vue?vue&type=script&lang=js"
export * from "./TaskDelivery.vue?vue&type=script&lang=js"
import style0 from "./TaskDelivery.vue?vue&type=style&index=0&id=1c8f4f84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f4f84",
  null
  
)

export default component.exports